module.exports = __webpack_public_path__ + "Олень.1c0c7db.png";